import script from "./RelayHub.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelayHub.vue?vue&type=script&setup=true&lang=ts"

import "./RelayHub.vue?vue&type=style&index=0&id=03b4309e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b4309e"]])

export default __exports__